export default function ShareButtons() {
  const shareButtons = document.querySelectorAll<HTMLElement>(".js-share-btn");
  const pageUrl = encodeURIComponent(window.location.href);
  const pageTitle = encodeURIComponent(document.title);

  if (shareButtons && shareButtons.length > 0) {
    shareButtons.forEach((btn) => {
      const socialType: string | null = btn.getAttribute("data-network");

      const handleFacebookShare = () => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
        window.open(url, "_blank");
      };

      const handleTwitterShare = () => {
        const url = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`;
        window.open(url, "_blank");
      };

      const handleLinkedInShare = () => {
        const url = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`;
        window.open(url, "_blank");
      };

      const handleShare = () => {
        if (socialType === "facebook") {
          handleFacebookShare();
        } else if (socialType === "twitter") {
          handleTwitterShare();
        } else if (socialType === "linkedin") {
          handleLinkedInShare();
        }
      };

      if (btn) {
        btn.addEventListener("click", handleShare);
      }
    });
  }
}
